export const colors: { [key: string]: string } = {
    primaryColor: '#484EA1',
    secondaryColor: '#0A0A1F',
    lightBG:'#F0F3F5',
}